import { useRef, useCallback } from 'react';

export const useTimeout = () => {
	const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	const set = useCallback((callback: () => void, delay: number) => {
		clear();
		timerRef.current = setTimeout(callback, delay);
	}, []);

	const clear = useCallback(() => {
		if (timerRef.current) {
			clearTimeout(timerRef.current);
			timerRef.current = null;
		}
	}, []);

	return { set, clear };
};
